(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/deposit-block/block-info.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/deposit-block/block-info.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$accountservicesR = svs.accountservicesReact.deposit.helpers.suspensionHelper,
  getSuspensionPeriod = _svs$accountservicesR.getSuspensionPeriod,
  getTotalPeriod = _svs$accountservicesR.getTotalPeriod,
  getProductName = _svs$accountservicesR.getProductName;
const DepositRestrictionsFirstDialog = svs.accountservicesReact.deposit.depositBlock.DepositRestrictionsFirstDialog;
const _svs$ui = svs.ui,
  Button = _svs$ui.ReactButton,
  Icon = _svs$ui.ReactIcon;
const _svs$utils$date = svs.utils.date,
  shortDateAndTime = _svs$utils$date.ShortDateAndTime,
  formatTime = _svs$utils$date.FormatTime;
const formatCurrency = svs.utils.format.Currency;
const setBlockInfo = blockInfo => {
  var _blockInfo$depositRes, _blockInfo$dayTimeLim;
  let button = null;
  let icon;
  let title;
  let text;
  if (blockInfo !== null && blockInfo !== void 0 && blockInfo.isBlockedNAR) {
    icon = 'spelpaus';
    title = 'Aktiv spelpaus';
    text = [React.createElement("p", {
      key: "0"
    }, "Du har st\xE4ngt av dig f\xF6r spel hos samtliga licensierade spelbolag i Sverige hos Spelinspektionen."), React.createElement("p", {
      key: "1"
    }, "Du kan inte s\xE4tta in pengar p\xE5 ditt spelkonto under spelpausen."), React.createElement("a", {
      className: "suspension-reminder",
      href: "http://www.spelpaus.se?scos=true",
      key: "2",
      rel: "noreferrer",
      target: "_blank"
    }, "www.spelpaus.se")];
  } else if (blockInfo !== null && blockInfo !== void 0 && blockInfo.netLossRestrictions) {
    icon = 'exclamation-sign';
    title = 'Just nu kan du inte spela eller sätta in pengar';
    text = [React.createElement("p", {
      key: "0"
    }, "Visste du att du de senaste 24 timmarna har f\xF6rlorat mer \xE4n", ' ', formatCurrency(blockInfo === null || blockInfo === void 0 ? void 0 : blockInfo.netLossRestrictions.amountLimit), ' ', "kr?"), React.createElement("p", {
      key: "1"
    }, "Av omtanke om dig kan du d\xE4rf\xF6r inte s\xE4tta in pengar eller spela online, Vegas eller i butik just nu. Du kan spela igen", ' ', shortDateAndTime(blockInfo === null || blockInfo === void 0 ? void 0 : blockInfo.netLossRestrictions.endTime, false, true).toLowerCase(), "."), React.createElement("p", {
      key: "2"
    }, "Vill du prata med n\xE5gon om dina spelvanor? Du n\xE5r oss p\xE5 0770-11 11 11.")];
  } else if (blockInfo !== null && blockInfo !== void 0 && (_blockInfo$depositRes = blockInfo.depositRestrictions) !== null && _blockInfo$depositRes !== void 0 && _blockInfo$depositRes.showSecondDialog) {
    icon = 'exclamation-sign';
    title = 'Du kan inte göra fler insättningar idag';
    text = [React.createElement("p", {
      key: "0"
    }, "Du har begr\xE4nsat dina ins\xE4ttningar idag och kan tidigast g\xF6ra ins\xE4ttningar imorgon igen.")];
  } else if (blockInfo !== null && blockInfo !== void 0 && blockInfo.ttRestriction) {
    icon = 'exclamation-sign';
    title = 'Just nu kan du inte spela eller sätta in pengar';
    if (svs.core.detect.feature('ft-gaming-responsibility-contact')) {
      button = React.createElement(Button, {
        block: true,
        href: "/spelkollskontakt",
        inverted: true,
        type: "button"
      }, "Kontakta oss");
      text = [React.createElement("p", {
        key: "0"
      }, "Anledningen till att du just nu inte kan spela eller s\xE4tta in pengar \xE4r att du den senaste tiden spelat mer riskfyllt."), React.createElement("p", {
        key: "1"
      }, "Innan du kan spela vidare beh\xF6ver du kontakta oss f\xF6r att prata om dina spelvanor. Du kan v\xE4lja mellan att chatta eller prata med n\xE5gon av v\xE5ra omsorgskommunikat\xF6rer.")];
    } else {
      text = [React.createElement("p", {
        key: "0"
      }, "Vi har f\xF6rs\xF6kt kontakta dig f\xF6r att hitta tid f\xF6r ett samtal om hur du k\xE4nner kring dina spelvanor. Tills vi f\xE5r tag p\xE5 dig kan du inte spela eller s\xE4tta in pengar."), React.createElement("p", {
        key: "1"
      }, "Kontakta oss p\xE5", ' ', React.createElement("a", {
        href: "tel:0498-20 02 91"
      }, "0498-20 02 91"), ' ', "f\xF6r att hitta tid f\xF6r ett samtal.")];
    }
  } else if (blockInfo !== null && blockInfo !== void 0 && blockInfo.suspensions) {
    const validTo = blockInfo !== null && blockInfo !== void 0 && blockInfo.suspensions.validTo ? formatTime('d/M, yyyy', blockInfo === null || blockInfo === void 0 ? void 0 : blockInfo.suspensions.validTo) : formatTime('d/M, yyyy', blockInfo === null || blockInfo === void 0 ? void 0 : blockInfo.suspensions.terminable);
    const product = getProductName(blockInfo === null || blockInfo === void 0 ? void 0 : blockInfo.suspensions.product, false, getTotalPeriod(blockInfo === null || blockInfo === void 0 ? void 0 : blockInfo.suspensions.period, blockInfo === null || blockInfo === void 0 ? void 0 : blockInfo.suspensions.terminationPeriod));
    const suspensionPeriod = getSuspensionPeriod(blockInfo === null || blockInfo === void 0 ? void 0 : blockInfo.suspensions);
    const validToOrSuspensionPeriod = (blockInfo === null || blockInfo === void 0 ? void 0 : blockInfo.suspensions.product) !== 'quickGames' ? suspensionPeriod : formatTime('d/M, yyyy, [klockan] HH:mm', blockInfo === null || blockInfo === void 0 ? void 0 : blockInfo.suspensions.validTo);
    icon = 'spelpaus';
    title = 'Aktiv spelpaus';
    text = [React.createElement("p", {
      key: "0"
    }, "Du kan inte s\xE4tta in pengar p\xE5 ditt spelkonto under pausen."), React.createElement("p", {
      key: "1"
    }, "Spelpausen g\xE4ller samtliga spel till", ' ', validTo, "."), blockInfo !== null && blockInfo !== void 0 && blockInfo.suspensions.terminable ? React.createElement("p", {
      key: "2"
    }, "Kontakta Kundservice efter spelpaus f\xF6r att aktivera", ' ', product, ' ', "efter", ' ', suspensionPeriod, ".") : React.createElement("p", {
      key: "3"
    }, "Spelpausen upph\xF6r automatiskt efter", ' ', validToOrSuspensionPeriod, "."), React.createElement("a", {
      href: "/spelpaus",
      key: "4"
    }, "L\xE4s mer om spelpaus h\xE4r.")];
  } else if (blockInfo !== null && blockInfo !== void 0 && (_blockInfo$dayTimeLim = blockInfo.dayTimeLimit) !== null && _blockInfo$dayTimeLim !== void 0 && _blockInfo$dayTimeLim.dayTimeExpired) {
    icon = 'exclamation-sign';
    title = 'Du har uppnått din dagliga tidsgräns';
    text = [React.createElement("p", {
      key: "0"
    }, "N\xE4r du har n\xE5tt din tidsgr\xE4ns kan du inte betala spel eller s\xE4tta in pengar.")];
  } else if ((blockInfo === null || blockInfo === void 0 ? void 0 : blockInfo.maxLimitRemaining) >= 0) {
    icon = 'exclamation-sign';
    title = 'Du kan inte göra fler insättningar den här månaden';
    text = [React.createElement("p", {
      key: "0"
    }, blockInfo.maxLimitRemaining > 0 ? "Du har ".concat(formatCurrency(blockInfo.maxLimitRemaining), " kr kvar att s\xE4tta in den h\xE4r m\xE5naden. Minsta ins\xE4ttning \xE4r 25 kr.") : 'Du har nått din maxgräns.')];
    button = React.createElement(Button, {
      className: "margin-top-1",
      href: svs.core.urlMapping.get('myLimitsMax'),
      size: 300,
      transparent: true
    }, "Till maxgr\xE4ns");
  }
  return [button, icon, title, text];
};
const BlockInfo = _ref => {
  var _blockInfo$depositRes2;
  let blockInfo = _ref.blockInfo,
    setIsCheckBlock = _ref.setIsCheckBlock;
  if (blockInfo !== null && blockInfo !== void 0 && (_blockInfo$depositRes2 = blockInfo.depositRestrictions) !== null && _blockInfo$depositRes2 !== void 0 && _blockInfo$depositRes2.showFirstDialog) {
    return React.createElement(DepositRestrictionsFirstDialog, {
      blockInfo: blockInfo,
      setIsCheckBlock: setIsCheckBlock
    });
  } else if (blockInfo) {
    const _setBlockInfo = setBlockInfo(blockInfo),
      _setBlockInfo2 = _slicedToArray(_setBlockInfo, 4),
      button = _setBlockInfo2[0],
      icon = _setBlockInfo2[1],
      title = _setBlockInfo2[2],
      text = _setBlockInfo2[3];
    return React.createElement("div", {
      className: "padding-top-2 align-center f-body"
    }, React.createElement(Icon, {
      icon: icon,
      size: "900"
    }), React.createElement("h2", {
      className: "h2 margin-v-2 line-height-120-override"
    }, title), text, button);
  }
  return null;
};
svs.accountservicesReact.deposit.depositBlock.BlockInfo = BlockInfo;

 })(window);